// src/content/media.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMedia } from '../api/content';

export const fetchMedia = createAsyncThunk(
  'content/fetchMedia',
  async (request) => {
    const data = await getMedia(request);
    return data.items ?? data;
  }
);

const initialState = {
  byCategory: {},
  byId: {},
  status: 'idle',
  error: null,
};

export const eventSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedia.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchMedia.fulfilled, (state, action) => {
        const type = action.meta.arg.type;     // category
        const items = action.payload || [];
        state.byCategory[type] = items;

        items.forEach((it) => {
          state.byId[String(it.id || it._id)] = it;
        });

        state.status = 'succeeded';
      })
      .addCase(fetchMedia.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default eventSlice.reducer;